export class ReservationVModel
{
  patientcode = '' ;
  resdate =  '2021-01-01';
  restime =  '2021-01-01';
  resroom = '' ;
  roomname = '' ;
  resdoc = '' ;
  docname = '' ;
  compcode = '' ;
  restype = '' ;
  resnotes = '' ;
  resstatus = '' ;
  resphone = '' ;
  restotime =  '2021-01-01';
  patientname = '' ;
  patientfname = '' ;
  roomtype = '' ;
  resduration = '' ;
  resdocname = '' ;
  id = 0;
  rsroomdesc = '' ;
  docnumber = '';
  modifiedDate = '2024-01-01'

}
